/* SlashCart hero animation (snippets/sc-hero-animation.liquid).
   The scene is CSS keyframes; this script only decides when it plays:
   - waits until the animation is on screen, then starts it (removes .sc-wait)
   - pauses while scrolled out of view (.sc-paused)
   - data-loop="false": plays once and holds the finished store
   - prefers-reduced-motion: shows the finished store as a still frame (.sc-still) */
(function () {
  var HOLD_AT_MS = 9000; // the "finished store" frame
  var VISIBLE_THRESHOLD = 0.25;

  function holdFinalFrame(root, state) {
    state.held = true;
    if (state.io) state.io.disconnect();
    root.classList.remove('sc-wait', 'sc-paused');

    var anims = root.getAnimations ? root.getAnimations({ subtree: true }) : [];
    if (anims.length) {
      anims.forEach(function (a) {
        a.pause();
        a.currentTime = HOLD_AT_MS;
      });
    } else {
      root.classList.add('sc-still');
    }
  }

  function watchForHold(root, state) {
    var scene = root.querySelector('#sc-scene');
    var sceneAnim = scene && scene.getAnimations ? scene.getAnimations()[0] : null;

    if (!sceneAnim) {
      setTimeout(function () {
        holdFinalFrame(root, state);
      }, HOLD_AT_MS);
      return;
    }

    // Follow the scene's own clock so time spent paused off screen is not counted.
    (function tick() {
      if (state.held) return;
      if (sceneAnim.currentTime >= HOLD_AT_MS) {
        holdFinalFrame(root, state);
        return;
      }
      requestAnimationFrame(tick);
    })();
  }

  function init(root) {
    if (root.hasAttribute('data-sc-init')) return;
    root.setAttribute('data-sc-init', '');

    var loop = root.getAttribute('data-loop') !== 'false';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      root.classList.remove('sc-wait');
      root.classList.add('sc-still');
      return;
    }

    var state = { held: false, started: false, io: null };
    root.scHeroAnim = state;

    function setVisible(visible) {
      if (state.held) return;
      root.classList.toggle('sc-paused', !visible);
      if (visible && !state.started) {
        state.started = true;
        root.classList.remove('sc-wait');
        if (!loop) watchForHold(root, state);
      }
    }

    if (!('IntersectionObserver' in window)) {
      setVisible(true);
      return;
    }

    state.io = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        // Start once a quarter of it is on screen; pause only when fully off screen.
        if (!entry.isIntersecting) {
          setVisible(false);
        } else if (entry.intersectionRatio >= VISIBLE_THRESHOLD) {
          setVisible(true);
        }
      },
      { threshold: [0, VISIBLE_THRESHOLD] }
    );
    state.io.observe(root);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.sc-hero-anim'), init);
  }

  initAll();

  // Theme editor: re-init when the section is re-rendered, clean up when it is removed.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    Array.prototype.forEach.call(event.target.querySelectorAll('.sc-hero-anim'), function (root) {
      if (root.scHeroAnim && root.scHeroAnim.io) root.scHeroAnim.io.disconnect();
    });
  });
})();
